import { render, staticRenderFns } from "./MwFormField.vue?vue&type=template&id=2b5bd688&"
import script from "./MwFormField.vue?vue&type=script&lang=js&"
export * from "./MwFormField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports